import { __assign, __rest } from "tslib";
import React from "react";
import Svg from "./Svg";

var SvgSync = function SvgSync(_a) {
  var _b = _a.size,
      size = _b === void 0 ? 24 : _b,
      props = __rest(_a, ["size"]);

  return React.createElement(Svg, __assign({
    fill: "currentColor",
    viewBox: "0 0 24 24",
    size: size
  }, props), React.createElement("path", {
    fill: "currentColor",
    d: "M12.567 1.258c-4.4.175-8.255 3-9.749 7.142a.25.25 0 01-.27.163l-1.69-.254a.5.5 0 00-.506.743l2.68 4.7a.5.5 0 00.785.107l3.77-3.746a.5.5 0 00-.279-.85l-1.715-.256a.25.25 0 01-.192-.35 8.259 8.259 0 117.866 11.59 1.25 1.25 0 10.045 2.5h.047a10.751 10.751 0 10-.792-21.487v-.002z"
  }));
};

export default SvgSync;